import type { SetupSelectionSet } from '@onxmaps/supergraph'
import { getItem, saveItem } from '@/plugins/storage'

import { onboardingLog } from '@/onboarding/lib/log'

/**
 * Maps local step name -> storage key (analyticsId or API key).
 * Populated during initOnboardingPages.
 */
export const onboardingStorageKeyMap = new Map<string, string>()

const storageKey = `fishSetupSelection`

export const setupSelectionStore = {
  /**
   * Stores a step selection in the current vertical's storage.
   * Overwrites existing entry if key already exists.
   */
  async store(key: string, selection: string[]): Promise<void> {
    const current = getItem<SetupSelectionSet[]>(storageKey) ?? []

    const existingIndex = current.findIndex((entry) => entry.key === key)
    const entry: SetupSelectionSet = { key, values: selection }

    if (existingIndex > -1) {
      current[existingIndex] = entry
    } else {
      current.push(entry)
    }

    await saveItem(storageKey, current)
    onboardingLog('Stored setup selection', { key, selection })
  },

  /**
   * Returns all stored SetupSelectionSets for the current vertical.
   * Returns empty array if nothing stored.
   */
  getAll(): SetupSelectionSet[] {
    const stored = getItem<SetupSelectionSet[]>(storageKey)
    if (!stored || !Array.isArray(stored) || stored.length === 0) {
      return []
    }
    return stored
  },
}
